import { render, staticRenderFns } from "./addFreightTemplate.vue?vue&type=template&id=c9d6a4d0&scoped=true"
import script from "./addFreightTemplate.vue?vue&type=script&lang=js"
export * from "./addFreightTemplate.vue?vue&type=script&lang=js"
import style0 from "./addFreightTemplate.vue?vue&type=style&index=0&id=c9d6a4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d6a4d0",
  null
  
)

export default component.exports